import { atom } from "recoil";

import { SalesRep } from "../../types/user";

export const waitingForAuthAtom = atom<boolean>({
  key: "waitingForAuthAtom",
  default: true,
});

export const showSignLoadingAtom = atom<boolean>({
  key: "showSignLoadingAtom",
  default: false,
});

export const signedInUserAtom = atom<SalesRep | null>({
  key: "signedInUserAtom",
  default: null,
});

export const signInEmailAtom = atom<string>({
  key: "signInEmailAtom",
  default: "",
});

export const signInEmailErrorAtom = atom<string>({
  key: "signInEmailErrorAtom",
  default: "",
});

export const signInEmailBlurredAtom = atom<boolean>({
  key: "signInEmailBlurredAtom",
  default: false,
});

export const signInPasswordAtom = atom<string>({
  key: "signInPasswordAtom",
  default: "",
});

export const signInRememberMeAtom = atom<boolean>({
  key: "signInRememberMeAtom",
  default: true,
});

export const signUpEmailAtom = atom<string>({
  key: "signUpEmailAtom",
  default: "",
});

export const signUpEmailErrorAtom = atom<string>({
  key: "signUpEmailErrorAtom",
  default: "",
});

export const skipStripeConnectAtom = atom<boolean>({
  key: "skipStripeConnectAtom",
  default: false,
});

export const signUpEmailBlurredAtom = atom<boolean>({
  key: "signUpEmailBlurredAtom",
  default: false,
});

export const signUpPasswordAtom = atom<string>({
  key: "signUpPasswordAtom",
  default: "",
});

export const letsGetToKnowFirstNameAtom = atom<string>({
  key: "letsGetToKnowFirstNameAtom",
  default: "",
});

export const letsGetToKnowLastNameAtom = atom<string>({
  key: "letsGetToKnowLastNameAtom",
  default: "",
});

export const letsGetToKnowPhoneNumberAtom = atom<string>({
  key: "letsGetToKnowPhoneNumberAtom",
  default: "",
});

export const letsGetToKnowRoleAtom = atom<string>({
  key: "letsGetToKnowRoleAtom",
  default: "",
});

export const myAccountFirstNameAtom = atom<string>({
  key: "myAccountFirstNameAtom",
  default: "",
});

export const myAccountLastNameAtom = atom<string>({
  key: "myAccountLastNameAtom",
  default: "",
});

export const myAccountPhoneNumberAtom = atom<string>({
  key: "myAccountPhoneNumberAtom",
  default: "",
});

export const myAccountRoleAtom = atom<string>({
  key: "myAccountRoleAtom",
  default: "",
});
